/* ============================================================================
   Bold Grip Socks — unlock-bar swap.
   When both the free-gift and free-shipping panels are present in the cart's
   unlock module, the "›" button toggles which one is visible (only one shows
   at a time, so the cart never stacks two progress bars). Delegated on the
   document so it keeps working after the cart drawer re-renders via AJAX.
   ========================================================================== */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-bm-unlock-swap]') : null;
    if (!btn) return;
    e.preventDefault();
    var mod = btn.closest('[data-bm-unlock]');
    if (!mod) return;
    var gift = mod.querySelector('[data-panel="gift"]');
    var ship = mod.querySelector('[data-panel="ship"]');
    if (!gift || !ship) return;
    var showingGift = !gift.hidden;
    gift.hidden = showingGift;
    ship.hidden = !showingGift;
    var label = btn.querySelector('[data-bm-unlock-label]');
    if (label) label.textContent = showingGift ? 'See free gift' : 'See free shipping';
  });
})();
